import {Column} from './columns';
import {HttpParams} from '@angular/common/http';
import { Collection } from 'src/app/back-office/Models/Collection';

export interface Grid {
  columns: Column[];
  service: any;
  method: string;
  gridData?: GridData;
  refresh?: any;
  searchPlaceholder?: string;
  params?: any;
  rowDetailTemplate?: any;
  rowDetailShowCallback?: Function;
  defaultSort?: string;
  defaultSortType?: 'asc' | 'desc';
  showButton: boolean;
  rememberURL?: string;
  root?: string;
  search?: GridSearchItem[];
  archive?: boolean;
  showIsCreditCheckbox?: boolean;
  doseNotHaveSearch?: boolean;
  multipleRowSearch?: boolean;
  bulkActionMethod?: string;
  inPopUp?: boolean;
  simpleSearch?: boolean;
  rows?: any[];
}

// its for when we have many dropdown search
export class SearchArray {
  index?: number;
  name: string;
  value: ServiceSearchItem | any;
  label: string;
  width?: number;
  selectedValue?: any;
}

// it for order
export class OrderArray {
  selectSearchOrder?: number;
  normalSearchOrder?: number;
  statusOrder?: number;
  datepickerOrder?: number;
  actionOrder?: number;
}

export class GridSearchItem {
  name: string;
  searchArrays: SearchArray[];
  order?: OrderArray[];
  type: string;
  label: string;
  calendarFromDate: string;
  calendarToDate: string;
  hasCalendar: boolean = false;
  calendarCustomWidth?: number;
  hasDropdownListFilter: boolean = true;
  hasBackofficeDropdownListFilter: boolean = true;
  hasStatus: boolean = false;
  hasInvoiceStatus: boolean = false;
  isInvoiceStatus: boolean = false;
  hasNormalSearch?: boolean = false;
  value: ServiceSearchItem;
}

export class ServiceSearchItem {

  public value = [];
  public query = {term: ''};

  constructor(private service: any, private method: string, private sortData: GridData, private receiveCallback: Function) {
    this.getData();
  }

  getData() {
    let params = new HttpParams();
    if (this.query.hasOwnProperty('term')) {
      params = params.set('query', this.query.term);
    }
    params = params.set('sortType', this.sortData.sortType);
    params = params.set('sortBy', this.sortData.sortBy);
    this.service[this.method](params).subscribe(res => this.value = this.receiveCallback(res));
  }
}

export class GridData {
  public dataPerPage?: number;
  public sortType?: string;
  public sortBy?: string;
  public searchData?: {}[];
}
